import React from 'react';
import { Image } from '../../../commonTypes/image';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { GridItem } from '../../Grid';
import { GridWithMargins, Heading, Subhead } from '../styles';
import { ImageWrapper, MainImage } from './styles';

export type HeroWithImageHorizontalProps = {
  heading: string;
  subhead?: string;
  image: Image;
} & ComponentProps;

/** Banner with text above an image, and no background */
const HeroWithImageHorizontal: React.FC<HeroWithImageHorizontalProps> = ({
  heading,
  subhead,
  image,
  ...props
}) => (
  <GridWithMargins alignLeft {...componentProps(props)}>
    <GridItem desktop={12} tabletLandscape={12}>
      <Heading>{heading}</Heading>
      {subhead && <Subhead>{subhead}</Subhead>}
      {image && (
        <ImageWrapper>
          <MainImage image={image} shouldEagerLoad={true} />
        </ImageWrapper>
      )}
    </GridItem>
  </GridWithMargins>
);

export default applyComponentTheme(HeroWithImageHorizontal, 'HeroWithImageHorizontal');
